import { number } from "prop-types"
import { Box } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import { colors } from "components/shared/admin_colors"

const PromoteCapacityWarning = ({ count }) => {
  const tooltipText =
    count > 1
      ? "When you promote these attendees, the capacity will be increased automatically."
      : "When you promote this attendee, the capacity will be increased automatically."

  return (
    <Box css={{ display: "flex", alignItems: "center" }} data-tooltip={tooltipText}>
      <Icon
        symbol="general#exclamation-triangle"
        style={{ color: colors.warning }}
        aria-label={tooltipText}
      />
    </Box>
  )
}

PromoteCapacityWarning.propTypes = {
  count: number.isRequired
}

export default PromoteCapacityWarning
